<template>
	<v-app id="inspire">
		<v-content>
			<v-container fluid fill-height>
				<v-layout align-center justify-center style="text-align: center;">
				<v-flex xs12 sm8 md4>
					<v-progress-linear :indeterminate="true"></v-progress-linear>
					<span>Logging out . . .</span>
				</v-flex>
				</v-layout>
			</v-container>
		</v-content>
	</v-app>
</template>

<script>
	import firebase from "firebase"
	import { mapActions, mapGetters, mapState } from "vuex"
	export default {
		mounted() {
			let self = this
			setTimeout(() => {
				firebase.auth().signOut().then(function() {
					self.$store.dispatch("setRole", null)
					self.$store.dispatch("setUser", null);
					self.$store.dispatch('setAuth', false)
				}).then(function(){
					localStorage.removeItem("firebaseui::rememberedAccounts", {});
					localStorage.removeItem("vuex", {});
					setTimeout(() => {
						window.location.href = "/login"
					}, 1000);
				}).catch(function(error) {console.log(error)})
			}, 3000)
		},
		methods: {
			...mapActions(["setAuth","setRole","setUser"]),
			...mapState(["Auth"])
		}
	}
</script>